// EWM-539 — build ordered breadcrumb crumbs for a category chain.
// Labels come from category/ancestor NAMES (clean); hrefs are derived
// from the leaf category's slug PATH so intermediate links point at the
// right ancestor URL without needing each ancestor's own path expanded.
// Shared so the PLP (EWM-538) can converge onto the same builder.
export interface BreadcrumbCrumb {
  label: string;
  href: string;
}

export interface CategoryCrumbInput {
  /** Leaf category display name. */
  name: string;
  /** Leaf category full slug path, e.g. `/root/sub/leaf`. */
  path: string;
  /** Ancestor chain, root-first; names only. */
  ancestors?: Array<{ name: string }>;
}

export const buildCategoryCrumbs = ({ name, path, ancestors = [] }: CategoryCrumbInput): BreadcrumbCrumb[] => {
  const segments = path.split('/').filter(Boolean);
  if (segments.length === 0) return [];

  const crumbs: BreadcrumbCrumb[] = ancestors.map((ancestor, index) => ({
    label: ancestor.name,
    href: `/${segments.slice(0, index + 1).join('/')}`,
  }));

  crumbs.push({ label: name, href: path });
  return crumbs;
};
